$(document).on('keyup','#partidosListaBuscador',function () {
    searchElements({'value':this.value,'elements':$("#buscarPartidoModal .rowPartido")});
});

function mostrarPartidos(){
    var mostrarPartidos = $('input[name=mostrarPartidos]:checked').val();
    if(mostrarPartidos==1){
        //Mostrar partidos del jugador
        $("#buscarPartidoModal .partit").each(function(k,v){
            if(!$(v).hasClass('enPartido')){
                $(v).closest('.rowPartido').addClass('hidden_');
            }
            if(!$("#buscarPartidoModal").hasClass('hr_init')) {
                $(this).closest('.rowPartido').append('<hr class="visible-xs hidden-sm hidden-md hidden-lg"/>');
            }
        });
        $("#buscarPartidoModal").addClass('hr_init');
        $("#partidosListaBuscador").attr('placeholder',Lang.get('partido.BuscarRivals'));
    }else{
        //Mostrar todos los partidos
        $("#buscarPartidoModal .rowPartido").removeClass('hidden_');  
        $("#partidosListaBuscador").attr('placeholder',Lang.get('partido.BuscarJugadores'));
    }
}